import React, { useEffect, useRef, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useDispatch, useSelector } from "react-redux";
import { getStaffCalendar } from "../../../redux/slice/bookingSlice";
import BookingDialogue from "./BookingDialogue";
import { Autocomplete, TextField } from "@mui/material";
import { getAllExpert } from "../../../redux/slice/expertSlice";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import StuffBusySlotDialogue from "./StuffBusySlotDialogue";
import Button from "../../extras/Button";
import BookingAddDialogue from "./BookingAddDialogue";

const localizer = momentLocalizer(moment);

export default function StaffCalendarPage() {
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [calendarData, setCalendarData] = useState([]);
  const [dummyEvents, setDummyEvents] = useState([]);
  const [allStaff, setAllStaff] = useState([]);

  const [staffList, setStaffList] = useState([]);

  // 👇 Track previous dialogue state
  const prevDialogueRef = useRef(dialogue);

  const handleSelectedEvent = (event) => {
    if (event?.status == 'booking') {
      dispatch(openDialog({ type: "booking", data: event?.data }))
    }
    else {
      dispatch(openDialog({ type: "busy", data: event?.data }))
    }
  };

  const fetchCalendar = () => {
    if (staffList?.length > 0) {
      const expertIds = staffList.map((s) => Number(s.id));
      dispatch(getStaffCalendar({ expertIds })).then((res) => {
        if (res.payload.status) {
          setCalendarData(res.payload.calendar);
        }
      });
    }
  };

  // 👇 Detect when dialogue closes and refetch calendar
  useEffect(() => {
    if (prevDialogueRef.current === true && dialogue === false) {
      fetchCalendar(); // Refetch calendar after closing dialogue
    }
    prevDialogueRef.current = dialogue;
  }, [dialogue]);


  // Fetch all staff members when the component mounts
  useEffect(() => {
    dispatch(
      getAllExpert({
        start: 0,
        limit: 0,
        search: 'ALL',
      })
    ).then((res) => {
      if (res.payload.status) {
        setAllStaff(res.payload.experts);
      }
    });
  }, [dispatch]);

  // Fetch calendar when staff list changes
  useEffect(() => {
    fetchCalendar();
  }, [staffList]);


  useEffect(() => {
    setData(calendarData);
    // console.log(calendarData);
    setDummyEvents(
      calendarData.map((event) => {
        const startDateTime = moment(
          `${event?.date} ${event?.start}`,
          "YYYY-MM-DD HH:mm"
        );
        const endDateTime = moment(
          `${event?.date} ${event?.end}`,
          "YYYY-MM-DD HH:mm"
        );
        return {
          id: event?.id,
          title: event?.expert,
          start: startDateTime.toDate(),
          end: endDateTime.toDate(),
          status: event?.status,
          eventData: event,
          data: event?.data,
        };
      })
    );
  }, [calendarData]);

  const eventStyleGetter = (event) => {
    let style = {};

    switch (event.status) {
      case "booking":
        style = {
          backgroundColor: "rgba(136, 230, 247, 0.5)",
          color: "#05879e",
        };
        break;
      case "busy":
        style = {
          backgroundColor: "rgba(251, 175, 190, .5)",
          color: "#b3092b",
        };
        break;
      case "completed":
        style = {
          backgroundColor: "rgba(147, 231, 195, 0.5)",
          color: "#1a8a59",
        };
        break;
      default:
        break;
    }

    return {
      style,
    };
  };

  return (
    <div>

      <div className="statusShow">
        <h1>Staff Calendar</h1>
        <Button
          className={`bg-button p-10 text-white m10-bottom`}
          text={`Add Booking`}
          bIcon={`fa-solid fa-user-plus`}
          onClick={() => {
            dispatch(openDialog({ type: "newBooking" }));
          }}
        />
        <h6 className="cancelStatus">Busy Slots</h6>
        <h6 className="pendingStatus">Bookings Slots</h6>
        {/* <h6 className="completedStatus">Completed</h6> */}
      </div>

      <Autocomplete
        value={staffList ?? []}
        multiple
        disablePortal
        id="tags-standard"
        options={allStaff || []}
        getOptionLabel={(option) => option.email}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(e, value) => {
          setStaffList(value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            label="Staff List"
          />
        )}
        fullWidth
      />

      {dummyEvents?.length > 0 && (
        <Calendar
          localizer={localizer}
          views={["month", "week", "day"]}
          events={dummyEvents}
          style={{ height: 600 }}
          startAccessor="start"
          endAccessor="end"
          eventPropGetter={eventStyleGetter}
          onSelectEvent={handleSelectedEvent}
        />
      )}

      {dialogue && dialogueType === "booking" && (
        <BookingDialogue setData={setData} data={data} />
      )}
      {dialogue && dialogueType === "busy" && (
        <StuffBusySlotDialogue setData={setData} data={data} />
      )}
      {dialogue && dialogueType === "newBooking" && (
        <BookingAddDialogue />
      )}
    </div>
  );
}
